import _ from "lodash";
import h from "../core/createElement";



export default function Pagination({ callback, current: _current, last, max: _max }) {
    let current = _current && +_current;
    const
        max = +_max || 7,
        range_pag = Math.ceil(max / 2),
        total = +last;

    const
        rotate = () => {
            let lowCut = current - range_pag, highCut = current + range_pag, pages = [];

            if (total <= max) pages = _.range(1, total + 1);

            else {
                current > range_pag && (pages.push(1), current > range_pag && pages.push('...'));

                lowCut < 0 && (highCut += Math.abs(lowCut));

                highCut > total && (lowCut -= (highCut - total - 1));

                for (let i = lowCut + 1; i < highCut; i++) {
                    if (i <= 0) i = 1;
                    if (i > total) continue;
                    pages.push(i);
                };

                current + (range_pag - 1) < total && (current + range_pag < total + 1 && pages.push('...'), pages.push(total));
            };

            return [
                current > 1 ? <a pg-index="#!-1" class="cdp_i"></a> : "",

                ...pages.map(el => <a pg-index={'#!' + el} class={`cdp_i ${el === current ? "active" : ''}`}>{el}</a>),

                current < total ? <a pg-index="#!+1" class="cdp_i"></a> : ""
            ];
        },
        handleClick = (e) => {
            if (!e.target.getAttribute('pg-index')) return;

            let pg = e.target.getAttribute('pg-index').replace('#!', '');

            if (pg === '+1') pg = current += 1;
            if (pg === '-1') pg = current -= 1;

            if (!+pg) return;

            if (typeof callback === 'function') callback({ page: pg });

            current = Number(pg);

            e.target.parentNode.replaceChildren(...rotate());
        };

    return <div class="cdp" onClick={e => handleClick(e)}> {rotate()} </div>;
}